module.exports = __webpack_public_path__ + "media/images/menu/carme-47f393ac9f3aafb5ce1b2aa0f98a221f.jpg";